{
  "validation.required": "{{label}} is een verplicht veld",
  "validation.minLength": "{{label}} moet minstens {{min}} tekens lang zijn",
  "validation.maxLength": "{{label}} kan niet langer zijn dan {{max}} tekens",
  "validation.contentTypeAlphanumeric": "{{label}} moet alfanumeriek zijn",
  "validation.contentTypeDate": "{{label}} moet een datum zijn",
  "validation.contentTypeDateBefore": "{{label}} moet een datum zijn vóór {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} moet een datum zijn na {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} moet een datum en tijd zijn",
  "validation.contentTypeDatetimeBefore": "{{label}} moet een datum zijn vóór {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} moet een datum zijn na {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} moet een e-mail zijn",
  "validation.contentTypeInteger": "{{label}} moet een getal zijn",
  "validation.contentTypeNumber": "{{label}} moet een getal zijn",
  "validation.contentTypeRegex": "{{label}} heeft het verkeerde formaat",
  "validation.contentTypeText": "{{label}} moet een tekst zijn",
  "validation.contentTypeTime": "{{label}} moet een tijd zijn",
  "validation.contentTypeUrl": "{{label}} moet een webadres zijn",
  "select-element.default-option": "Selecteer...",
  "button-element.network-required": "U bent momenteel offline. Maak een netwerkverbinding om door te gaan."
}